import { useEffect } from "react";
import axios from "axios";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom"; // or

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  //baseURL: "https://127.0.0.1:8443/api",
});

export const useAxiosPrivate = () => {
  const { auth, clearAuth } = useAuth();
  const token = auth.token;
  const navigate = useNavigate();

  useEffect(() => {
    const requestIntercept = axiosInstance.interceptors.request.use(
      (config) => {
        if (token && config.headers) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Catch 401 and clear token
    const responseIntercept = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          clearAuth();
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.request.eject(requestIntercept);
      axiosInstance.interceptors.response.eject(responseIntercept);
    };
  }, [token, clearAuth, navigate]);

  return axiosInstance;
};
